<quill-editor [(ngModel)]="editorText" [placeholder]="placeholder" name="description" [styles]="textEditorStyle" class="editor"
    [modules]="textEditorModules" [formats]="allowedFormats" #description="ngModel" (onEditorCreated)="onEditorCreated($event)" (onEditorChanged)="onEditorChanged($event)">
</quill-editor>
<div *ngIf="!textLengthBelowMax; else descriptionInfo" class="description error">
    Die Beschreibung darf nicht länger sein als {{ maxTextLength }} Zeichen
    (aktuell {{ pureTextLength }}).
</div>
<ng-template #descriptionInfo>
    <div class="description">
        Aktuelle Zeichenlänge (inklusive Formatierung)
        {{ pureTextLength }} (Max: {{ maxTextLength }})
    </div>
</ng-template>